export default "__VITE_ASSET__BLbIcNQL__"